var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "btn-new-event",
      on: {
        click: function($event) {
          _vm.btnClick()
        }
      }
    },
    [
      _c(
        "span",
        { staticClass: "btn-new-event-wrapper-icon" },
        [
          _c("Icon", {
            staticClass: "btn-new-event-icon",
            class: ["CreateEvent" == _vm.item.name ? "new-event-icon" : ""],
            attrs: { name: _vm.item.iconName }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("a", { staticClass: "btn-new-event-text" }, [
        _c("span", { staticClass: "span-btn-text" }, [
          _vm._v(_vm._s(_vm.item.btnText))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1eb34980", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb34980","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subHeaders/SubHeaderButton.vue
// module id = 2029
// module chunks = 1